import { createTheme } from '@mui/material/styles';

export const defaultCustomerConfig = {
  primaryColor:    '#1A2C5B',
  ctaColor:        '#008080',
  ctaHoverColor:   '#006b6b',
  backgroundColor: '#F4F7FB',
  companyName:     'מור גמל ופנסיה',
  logo:            '/logos/More/more.png',
  favicon:         '/logos/More/favicon.ico',
  logoHeight:      40,
  footerDisclaimer: true,
  disclaimerText:  'מהות הכלי והיעדר ייעוץ: התוצאות המוצגות במחשבון זה מהוות סימולציה אינפורמטיבית בלבד ואינן בגדר המלצה, שיווק פנסיוני או ייעוץ השקעות. המידע אינו מחליף ייעוץ אישי המותאם לצרכי המשתמש, המבוצע על ידי בעל רישיון בהתאם להוראות הדין. קבלת החלטות בנוגע למוצרים פנסיוניים מחייבת בחינה מעמיקה של נתוני העמית בפועל. • בסיס הנתונים והנחות העבודה: התחשיב מבוסס על הנתונים שהוזנו על ידי המשתמש ועל הנחות אקטואריות וטכניות הנגזרות מתקנון הקרן והוראות הרגולציה החלות על קרנות הפנסיה. • מוגבלות התחזית ושינויים עתידיים: הנתונים המוצגים הינם אומדן מקורב וחלקי בלבד למקרי פרישה, נכות או שארים. מדובר בהנחות כלליות אשר עשויות להשתנות בעתיד כתוצאה משינויים בשוק ההון, בחקיקה או בנתוניו האישיים של המשתמש, ועל כן אין בתוצאות כדי לחייב את החברה באופן כלשהו. • קביעת הזכאות הסופית: הזכאות המכרעת לקבלת קצבה וגובהה ייקבעו אך ורק במועד אירוע המזכה (פרישה/נכות/מוות), וזאת על פי הוראות תקנון הקרן העדכני לאותה עת, הנתונים המדויקים המופיעים בחשבון העמית והסדר התחיקתי המחייב. • הגבלות והחרגות (קצבת נכות): לתשומת ליבך, עמית שקיבל קצבת נכות במהלך 24 החודשים שקדמו להגשת בקשת הפרישה, אינו רשאי לבחור במסלול של תקופת תשלומים מובטחים, בהתאם לתקנון. לפיכך, סימולציה הכוללת הבטחת תשלומים במקרה כזה אינה רלוונטית ואינה תקפה. • דמי ניהול ומיסוי: החישוב בוצע בהנחת עבודה של דמי ניהול בשיעור של 0.3%. יודגש כי כל הסכומים המוצגים הינם סכומי ברוטו, ולפני ניכוי תשלומי חובה על פי דין, לרבות מס הכנסה ודמי ביטוח לאומי. • מועד הזכאות: על פי התקנון, מועד הזכאות לקבלת הקצבה יחול ב-1 לחודש העוקב למועד בו אושרה הבקשה על ידי החברה. תחזית זו ניתנה בהתאם ליתרה לחישוב קצבה שהוזנה בתהליך. ככל שיהיה פער בין הנתונים שהוזנו ליתרה בפועל ביום חישוב הקצבה, סכום קצבת הפנסיה צפוי להשתנות. ככל שגילך בתום תקופת התשלומים המובטחים שבחרת יעלה על גיל 87, תקוצר תקופת התשלומים המובטחים בה בחרת למספר החודשים שבסופם גילך לא יעלה על 87.',
  testingMode:     false,
  insuranceEndAge: 67,
  showInsuranceEndAge: false,
  showClientId:        false,
  showClientName:      true,
  retirementYearsBack: 3,
  mortalityImprovementModel: 'monthly',
  formLayout: 'v2',
};

// ─── Focus indicator — A-2-Z audit, row 14 (כללי / סימון פוקוס) ──────────────
//
// A two-colour ring — light inside the control, dark just outside — applied ONLY to the controls
// the auditor reported as having an invisible focus marker. Everything on a white surface keeps
// its existing single teal ring (4.44 – 4.77:1) and is deliberately left untouched.
//   • the teal buttons (חישוב, הורדת קובץ)   → the white ring sits ON the teal, not beside it
//   • links on the dark header/footer banners → the white inner ring carries it
//
// This replaces a single-colour ring whose colour was chosen for one surface and then painted
// on another: `outline-offset` pushed the white CTA ring outside the button onto the light page
// (measured 1.13:1), and the global teal ring landed on the dark header/footer (1.21 – 2.52:1).
// Measured after the change, on the reported controls only: 5.71 – 12.57:1 against their
// immediate surroundings, where WCAG 1.4.11 asks for 3:1.
// Exported so the language toggle — the one reported control that cannot be reached from the
// theme (it shares its MUI classes with the "ניקוי" button, which must keep the teal ring) —
// uses the same definition instead of a copy.
export const FOCUS_RING = {
  outline: '2px solid #1A2C5B',
  outlineOffset: '1px',
  boxShadow: 'inset 0 0 0 2px #FFFFFF',
};

export function createAppTheme(config = defaultCustomerConfig, direction = 'rtl') {
  return createTheme({
    breakpoints: {
      values: { xs: 0, sm: 480, md: 768, lg: 1100, xl: 1536 },
    },
    direction,
    palette: {
      primary:    { main: config.primaryColor },
      secondary:  { main: config.ctaColor },
      background: { default: config.backgroundColor, paper: '#FFFFFF' },
    },
    typography: {
      fontFamily: '"Heebo", "Segoe UI", Arial, sans-serif',
      h5: { color: config.primaryColor, fontWeight: 700 },
      h6: { color: config.primaryColor, fontWeight: 600 },
      body2: { color: '#5E6069' },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          'a:focus-visible': FOCUS_RING,
        },
      },
      MuiButton: {
        styleOverrides: {
          containedSecondary: {
            backgroundColor: config.ctaColor,
            '&:hover': { backgroundColor: config.ctaHoverColor },
            color: '#FFFFFF',
            fontWeight: 700,
          },
          root: {
            // A-2-Z row 14 — same pulsating TouchRipple as on radios/icon buttons.
            // The original finding says "על הכפתורים" (buttons in general), so the CTA and the
            // language toggle are covered by it too. Outline stays the only focus indicator.
            '& .MuiTouchRipple-root': { display: 'none' },
            '&:focus-visible': {
              outline: '2px solid #008080',
              outlineOffset: '2px',
              boxShadow: 'none',
            },
            // Teal buttons only (חישוב, הורדת קובץ PDF): the single-colour ring was invisible
            // on them, so these get the two-colour ring. Every other button keeps the teal ring.
            // MUI v9 emits `contained` and `colorSecondary` as separate classes — there is no
            // combined `MuiButton-containedSecondary` class to match on.
            '&.MuiButton-contained.MuiButton-colorSecondary:focus-visible': FOCUS_RING,
          },
        },
      },
      // A-2-Z audit, row 14 — "יש עדיין כתם בנוסף למסגרת על כפתורי רדיו + כפתורי פחים".
      //
      // The blot is NOT a box-shadow: measurement shows box-shadow is already `none` while a
      // .MuiTouchRipple-ripplePulsate element (opacity ~0.15) is painted inside the control.
      // ButtonBase pulsates it on keyboard focus:
      //     if (focusVisible && focusRipple && !disableRipple) ripple.pulsate()
      // Radio reaches ButtonBase through SwitchBase, which sets focusRipple: !disableFocusRipple.
      //
      // `disableRipple` works for IconButton but does NOT reach ButtonBase through SwitchBase in
      // MUI v9 — verified: neither theme defaultProps nor an explicit prop on <Radio> removes the
      // ripple. So the ripple element is hidden in CSS, which is independent of prop plumbing and
      // survives MUI upgrades. The 2px teal outline remains the sole focus indicator.
      MuiRadio: {
        defaultProps: { disableRipple: true },
        styleOverrides: {
          root: {
            '& .MuiTouchRipple-root': { display: 'none' },
            '&:hover, &.Mui-focusVisible': { backgroundColor: 'transparent' },
          },
        },
      },
      MuiIconButton: {
        defaultProps: { disableRipple: true },
        styleOverrides: {
          root: {
            '& .MuiTouchRipple-root': { display: 'none' },
            '&:focus-visible': {
              outline: '2px solid #008080',
              outlineOffset: '2px',
              boxShadow: 'none',
            },
          },
        },
      },
      MuiButtonBase: {
        styleOverrides: {
          root: {
            '&:focus-visible, &.Mui-focusVisible': {
              outline: '2px solid #008080',
              outlineOffset: '2px',
              boxShadow: 'none',
            },
          },
        },
      },
      MuiTextField: {
        defaultProps: { variant: 'outlined', size: 'small', fullWidth: true },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            boxShadow: '0 2px 12px rgba(26,44,91,0.08)',
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          select: {
            '&:focus-visible': {
              outline: '2px solid #008080',
              outlineOffset: '2px',
              borderRadius: '4px',
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(0, 0, 0, 0.54)',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: config.primaryColor,
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: config.ctaColor,
            },
          },
          input: {
            '&::placeholder': {
              color: 'rgba(0,0,0,0.6)',
              opacity: 1,
            },
            '&:focus-visible': {
              outline: '2px solid #008080',
              outlineOffset: '-2px',
            },
          },
        },
      },
    },
  });
}
